import { type IFlags } from 'flagsmith/types.d';

type GetAbTestInfoResult = {
  ab_segment: string;
} | null;

const EXP_PREFIX = 'exp';

export const getAbTestInfo = (flags?: IFlags): GetAbTestInfoResult => {
  if (!flags){
    return null;
  }

  const abFlags = Object.entries(flags).reduce((acc, [key, value]) => {
    if (key.startsWith(EXP_PREFIX) && value.enabled) {
      acc.push(`${key}:${value.value}`);
    }
    return acc;
  }, [] as string[]).join('|');

  return abFlags ? { ab_segment: abFlags } : null;
};
